import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "dialog" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "message" }
const _hoisted_4 = { class: "dialog-main-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("dialog", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ButtonIcon, {
          class: "icon",
          icon: "question"
        }),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.confirmation.message), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onOk()))
        }, "OK"),
        _createElementVNode("button", {
          class: "dialog-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClose()))
        }, "キャンセル")
      ])
    ], 512)
  ]))
}